(function (window, document, $) {

    $(document).ready(function () {
        //abonnement Fixed Floating Elements 
        if (($(".single-training").length || $(".mail-en-win").length) && $('.abonnement-content-side__content').length ) {
            var headerHeight = $('.header').height();
            var $contentside = $('.abonnement-content-side__content');
            var popularTop = $contentside.offset().top - headerHeight;
            var popularHeight = $contentside.outerHeight(true);
            var related = $('.footer').offset().top;
            var contentarea = $('.abonnement-content-main__content');
            var contentBottom = contentarea.position().top + contentarea.outerHeight(true);

            // make the abonnement-content-side__content element a fixed floating element if the content is bigger then the popular element 
            // and the product is not sold out (has a quantity field) 
            if (contentBottom > popularHeight) {
                $(window).scroll(function (event) {

                    if ($(window).width() < 991) {
                        $contentside.removeAttr("style");
                        $contentside.removeClass('fixed');
                        return;
                    }

                    var y = $(this).scrollTop();
                    if (y >= popularTop) {
                        $contentside.addClass('fixed');
                    } else {
                        $contentside.removeClass('fixed');
                    }

                    if (y >= contentBottom - popularHeight - popularTop) {
                        if (y >= popularTop) {
                            $contentside.removeClass('fixed');
                            $contentside.css('margin-top', contentBottom - popularHeight - popularTop);
                        }
                    } else {
                        $contentside.addClass('fixed difficult');
                        $contentside.removeAttr("style");
                    }
                });
            }

            // if the content is smaller then the popular element make the content element the same height 
            if (contentBottom < popularHeight) {
                contentarea.height(popularHeight);
            }
        }
    });

}(window, document, jQuery));
